/**
 * The root `<div>` carries the className. There is always exactly one element
 * and it is always the root, whether the host component resolved or not.
 */
export const resolveRendersOwnElement = (): boolean => true;
